import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomDocumentsReviewComponent } from 'src/app/components/custom-documents-review/custom-documents-review.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { InventoryPeriodModel } from 'src/app/models/inventory/inventory-period.model';
import { RentalPeriodModel } from 'src/app/models/rental/rental-period.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { DocumentsOpenedTableModel } from 'src/app/models/tables/inventory/documents-opened-table.model';
import { InventoryPeriodTableModel } from 'src/app/models/tables/inventory/inventory-period-table.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryPeriodService } from 'src/app/services/inventory/inventory-period.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { RegisterInventoryPeriodComponent } from '../register-inventory-period/register-inventory-period.component';

@Component({
  selector: 'app-inventory-period',
  templateUrl: './inventory-period.component.html',
  styleUrls: ['./inventory-period.component.scss'],
  standalone: false
})
export class InventoryPeriodComponent implements OnInit {

  @ViewChild('documentsOpenedModal') documentsOpenedModalComponent?: CustomModalComponent | null = null;
  @ViewChild('registerModal') registerModalComponent?: CustomModalComponent | null = null;

  ascendant: boolean = true;
  ascendantDocuments: boolean = true;
  columnSort: string | null = null;
  columnSortDocuments: string | null = null;
  componentRegisterInventoryPeriod = RegisterInventoryPeriodComponent;
  componentDocumentsOpened = CustomDocumentsReviewComponent;
  data: PagedResponseModel<InventoryPeriodTableModel> = new PagedResponseModel<InventoryPeriodTableModel>();
  dataDocuments: PagedResponseModel<DocumentsOpenedTableModel> = new PagedResponseModel<DocumentsOpenedTableModel>();
  documentsForDelete: boolean = false;
  filters: ColumnResponseModel[] = [];
  header: ColumnResponseModel[] = [];
  headerDocuments: ColumnResponseModel[] = [];
  inputsForDocumentsOpenedModal$ = new BehaviorSubject<any>({
    infoMessage: '',
    headers: [],
    data: []
  });
  inputsForRegisterModals$ = new BehaviorSubject<any>({
    inventoryPeriodContract: new RentalPeriodModel(),
    permissionUpdatable: false
  });
  inventoryPeriodContract: InventoryPeriodModel = new InventoryPeriodModel();
  inventoryPeriodId: number = 0;
  isOpened: string | undefined = undefined;
  infoMessage: string = 'Para cerrar el período no deben existir documentos abiertos ni predevoluciones pendientes. Por favor valide los siguientes documentos.';
  limit: number = 10;
  limitDocuments: number = 10;
  nameWindow: string = 'Períodos de Inventario';
  output$ = new Subject<any>();
  page: number = 1;
  pageDocuments: number = 1;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  subscription: Subscription;
  tableActions: TableAction[] = [
    {
      label: 'Modificar',
      icon: 'pi pi-sync',
      action: 'toggle'
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: 'delete'
    },
  ];
  url: string = 'inventory-period';

  constructor(private headerService: HeaderService,
    private inventoryPeriodService: InventoryPeriodService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private windowService: WindowService) { }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    const filters = localStorage.getItem(`${this.url}`);
    if (filters) this.filters = JSON.parse(filters);
    this.getPermission();
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getAllInventoryPeriodsWithPagination(),
    ]);
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeDocumentsOpened(payload);
          break;
        case 'onExport':
          this.exportDocuments();
          break;
        case 'onReload':
          this.onReload(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeStateInventoryPeriod(inventoryPeriod: InventoryPeriodTableModel) {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado del período de inventario.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    const action = inventoryPeriod.active ? 'Cerrar' : 'Abrir';
    const message = `¿Realmente desea ${action.toLowerCase()} el período de inventario?`;
    const result = await Swal.fire({
      title: 'Atención',
      text: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    });
    if (!result.isConfirmed) { return; }
    this.documentsForDelete = false;
    this.infoMessage = 'Para cerrar el período no deben existir documentos abiertos ni predevoluciones pendientes. Por favor valide los siguientes documentos.';
    await this.getAllDocuments();
    if (this.dataDocuments && this.dataDocuments.totalItems > 0) {
      await this.getColumnsForDocuments();
      this.documentsOpenedModalComponent && this.documentsOpenedModalComponent.show();
    } else {
      try {
        const response = await firstValueFrom(this.inventoryPeriodService.setActiveInventoryPeriod(this.inventoryPeriodId));
        const successMessage = response.active ? 'El período de inventario fue abierto exitosamente.'
          : 'El período de inventario fue cerrado exitosamente.';
        this.toastHandlerService.showToast('success', successMessage);
        await this.getAllInventoryPeriodsWithPagination();
      } catch (error) {
        console.error('Error al cambiar el estado del período de inventario.', error);
      }
    }
  }

  async delete(inventoryPeriod: InventoryPeriodTableModel) {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para eliminar períodos de inventario.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!inventoryPeriod.active) {
      this.toastHandlerService.showToast('warning', `No es posible eliminar, el período de inventario se encuentra CERRADO.`);
      return;
    }
    const result = await Swal.fire({
      title: 'Atención',
      text: '¿Realmente desea eliminar el período de inventario?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    });
    if (!result.isConfirmed) { return; }
    this.documentsForDelete = true;
    this.infoMessage = 'Para eliminar el período no deben existir documentos. Por favor valide los siguientes documentos.';
    await this.getAllDocuments();
    if (this.dataDocuments && this.dataDocuments.totalItems > 0) {
      await this.getColumnsForDocuments();
      this.documentsOpenedModalComponent && this.documentsOpenedModalComponent.show();
    } else {
      try {
        await firstValueFrom(this.inventoryPeriodService.deleteInventoryPeriod(inventoryPeriod.inventoryPeriodId));
        this.toastHandlerService.showToast('success', 'El período de inventario fue eliminado exitosamente.');
        await this.getAllInventoryPeriodsWithPagination();
      } catch (error) {
        console.error('Error al eliminar el período de inventario.', error);
      }
    }
  }

  async exportDocuments() {
    try {
      if (this.documentsForDelete) {
        const response = await firstValueFrom(this.inventoryPeriodService.exportDocumentsForDelete(this.columnSortDocuments, this.ascendantDocuments,
          this.inventoryPeriodId));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Documentos.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        const response = await firstValueFrom(this.inventoryPeriodService.exportDocumentsOpenedConsultation(this.columnSortDocuments, this.ascendantDocuments,
          this.inventoryPeriodId));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Documentos.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar los documentos pendientes.', error);
    }
  }

  async exportGeneralConsultation() {
    try {
      const response = await firstValueFrom(this.inventoryPeriodService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant));
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Períodos de Alquiler.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar los períodos de inventario.', error);
    }
  }

  async getAllDocuments() {
    try {
      if (this.documentsForDelete) {
        this.dataDocuments = await firstValueFrom(this.inventoryPeriodService.getAllDocumentsForDeleteWithPagination(this.pageDocuments, this.limitDocuments,
          this.columnSortDocuments, this.ascendantDocuments, this.inventoryPeriodId));
      } else {
        this.dataDocuments = await firstValueFrom(this.inventoryPeriodService.getAllDocumentsOpenedWithPagination(this.pageDocuments, this.limitDocuments,
          this.columnSortDocuments, this.ascendantDocuments, this.inventoryPeriodId));
      }
      this.updateInputs();
    } catch (error) {
      console.error('Error al buscar los documentos.', error);
      throw error;
    }
  }

  async getAllInventoryPeriodsWithPagination() {
    try {
      this.data = await firstValueFrom(this.inventoryPeriodService.getAllInventoryPeriodsWithPagination(this.page, this.limit,
        this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al buscar los períodos de inventario.', error);
    }
  }

  async getColumnsForDocuments() {
    try {
      if (this.headerDocuments.length === 0) {
        this.headerDocuments = await firstValueFrom(this.inventoryPeriodService.getColumnsForDocumentsOpened());
        this.updateInputs();
      }
    } catch (error) {
      console.error('Error al obtener las columnas para la consulta de documentos pendientes.', error);
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.header.length === 0) {
        this.header = await firstValueFrom(this.inventoryPeriodService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general de los períodos de inventario.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await this.getPermissionProfileByUrl();
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  newRegister() {
    this.inventoryPeriodContract = new InventoryPeriodModel();
    this.openRegisterModal();
  }

  openRegisterModal() {
    this.inputsForRegisterModals$.next({
      inventoryPeriodContract: this.inventoryPeriodContract,
      permissionUpdatable: this.permissionUpdatable
    });
    this.registerModalComponent && this.registerModalComponent.show();
  }

  async onAction(event: { action: string, item?: InventoryPeriodTableModel, selectedItems?: number[] }) {
    this.inventoryPeriodId = event.item != null ? event.item.inventoryPeriodId : 0;
    if (event.action === 'toggle' && event.item) {
      await this.changeStateInventoryPeriod(event.item);
    }
    if (event.action === 'delete' && event.item) {
      await this.delete(event.item);
    }
  }

  async onPageChangeDocumentsOpened(event: { page: number; pageSize: number; sortField?: string; sortOrder: number }) {
    this.pageDocuments = event.page;
    this.limitDocuments = event.pageSize;
    this.columnSortDocuments = event.sortField ?? null;
    this.ascendantDocuments = event.sortOrder === 1;
    await this.getAllDocuments();
  }

  async onExport() {
    await this.exportGeneralConsultation();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number; sortField?: string; sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField ?? null;
    this.ascendant = event.sortOrder === 1;
    await this.getAllInventoryPeriodsWithPagination();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async onReload(reload: any) {
    if (reload) {
      await this.getAllInventoryPeriodsWithPagination();
    }
  }

  updateInputs() {
    this.inputsForDocumentsOpenedModal$.next({
      headers: this.headerDocuments,
      data: this.dataDocuments,
      infoMessage: this.infoMessage
    });
  }
}
